import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [allVendors, setAllVendors] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [filteredPincodes, setFilteredPincodes] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [vendorTasksInfo, setVendorTasksInfo] = useState({});
  const [showDetails, setShowDetails] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalVendors, setTotalVendors] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchCity, setSearchCity] = useState("");
  const [searchPincode, setSearchPincode] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isCityOpen, setIsCityOpen] = useState(false);
  const [isPincodeOpen, setIsPincodeOpen] = useState(false);

  const [filters, setFilters] = useState({
    registerAs: "",
    city: "",
    category: "",
    shopName: "",
    pincode: "",
    minTask: "",
    maxTask: "",
    minEarning: "",
    maxEarning: "",
    mobile: "",
    employee: "",
    fromDate: "",
    toDate: "",
  });
  const limit = 50;

  const cityDropdownRef = useRef(null);
  const pincodeDropdownRef = useRef(null);

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const fetchVendors = async (page = 1, useBackendFilters = false) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token missing. Please log in.");
        return { vendors: [], totalPages: 0, totalVendors: 0 };
      }

      setLoading(true);
      console.log(`Fetching page ${page} with limit ${limit}, useBackendFilters: ${useBackendFilters}`);
      console.log('Current cities:', cities.length);
      console.log('Current categories:', categories.length);

      const queryParams = new URLSearchParams();
      
      if (!useBackendFilters) {
        queryParams.append('page', page);
        queryParams.append('limit', limit);
      }
      
      if (useBackendFilters) {
        // Always add pagination even with filters
        queryParams.append('page', page);
        queryParams.append('limit', limit);
        
        if (filters.registerAs) {
          queryParams.append('registerAs', filters.registerAs);
          console.log('Backend filter - registerAs:', filters.registerAs);
        }
        if (filters.city) {
          queryParams.append('city', filters.city);
          console.log('Backend filter - city:', filters.city);
        }
        if (filters.category) {
          queryParams.append('category', filters.category);
          console.log('Backend filter - category:', filters.category);
        }
        if (filters.shopName) {
          queryParams.append('shopName', filters.shopName);
          console.log('Backend filter - shopName:', filters.shopName);
        }
        if (filters.pincode) {
          queryParams.append('pincode', filters.pincode);
          console.log('Backend filter - pincode:', filters.pincode);
        }
        if (filters.mobile) {
          queryParams.append('mobile', filters.mobile);
          console.log('Backend filter - mobile:', filters.mobile);
        }
        if (filters.employee) {
          queryParams.append('employee', filters.employee);
          console.log('Backend filter - employee EXACT match:', filters.employee);
        }
        if (filters.minTask) {
          queryParams.append('minTask', filters.minTask);
          console.log('Backend filter - minTask:', filters.minTask);
        }
        if (filters.maxTask) {
          queryParams.append('maxTask', filters.maxTask);
          console.log('Backend filter - maxTask:', filters.maxTask);
        }
        if (filters.minEarning) {
          queryParams.append('minEarning', filters.minEarning);
          console.log('Backend filter - minEarning:', filters.minEarning);
        }
        if (filters.maxEarning) {
          queryParams.append('maxEarning', filters.maxEarning);
          console.log('Backend filter - maxEarning:', filters.maxEarning);
        }
        if (fromDate) {
          const [year, month, day] = fromDate.split('-');
          const formattedDate = `${day}-${month}-${year}`;
          queryParams.append('fromDate', formattedDate);
          console.log('Backend filter - fromDate:', formattedDate);
        }
        if (toDate) {
          const [year, month, day] = toDate.split('-');
          const formattedDate = `${day}-${month}-${year}`;
          queryParams.append('toDate', formattedDate);
          console.log('Backend filter - toDate:', formattedDate);
        }
      }

      const res = await axios.get(
        `https://visitguru.in/api/v1/freelancer/getAllfreelancer?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          timeout: 30000
        }
      );

      console.log('API Response:', res.data);
      console.log('Query URL:', `https://visitguru.in/api/v1/freelancer/getAllfreelancer?${queryParams.toString()}`);
      const data = res.data;

      if (data.success && Array.isArray(data.data)) {
        console.log(`Received ${data.data.length} vendors for page ${page}`);
        console.log(`Total pages: ${data.totalPages}, Total vendors: ${data.totalFreelancers}`);

        const validVendors = data.data
          .filter((vendor) => {
            if (!vendor._id || vendor.isDeleted) {
              return false;
            }
            return true;
          })
          .map((vendor) => ({
            ...vendor,
            registeredAs: vendor.registerAs || vendor.registeredAs || "N/A",
            firstName: vendor.firstName || "",
            lastName: vendor.lastName || "",
            mobile: vendor.mobile || "",
            shopName: vendor.shopName || "",
            city: vendor.city || "",
            category: vendor.category || "",
            pincode: vendor.pincode || "",
            createdAt: vendor.createdAt || new Date().toISOString(),
            employees: vendor.employees || [],
            totalEmployee: vendor.totalEmployee || 0,
            vendorID: vendor.vendorID || "N/A",
            address: vendor.address || "N/A",
            email: vendor.email || "N/A",
            Emergencymobile: vendor.Emergencymobile || "N/A",
            DOB: vendor.DOB || "N/A",
            totalTask: vendor.totalTask || 0,
            isBlocked: vendor.isBlocked || false,
            employeeNames: vendor.employeeNames || [],
            area: vendor.area || "N/A",
          }));

        const result = {
          vendors: validVendors,
          totalPages: data.totalPages || 1,
          totalVendors: data.totalFreelancers || validVendors.length
        };

        console.log('Returning result:', result);
        return result;
      } else {
        console.log('API returned unsuccessful response:', data);
        toast.error("Failed to load vendors.");
        return { vendors: [], totalPages: 0, totalVendors: 0 };
      }
    } catch (error) {
      console.error('Error in fetchVendors:', error);
      console.error('Error details:', error.response?.data);
      const errorMsg = error.response?.data?.message || error.message || "Unknown error";
      toast.error("Error fetching vendors: " + errorMsg);
      return { vendors: [], totalPages: 0, totalVendors: 0 };
    } finally {
      setLoading(false);
    }
  };

  const fetchCities = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.log('No token found for cities');
        return [];
      }
      console.log('Fetching cities from API...');
      const res = await axios.get("https://visitguru.in/api/v1/city/getCity", {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 30000
      });
      console.log('Cities API response:', res.data);
      const cities = res.data.success && Array.isArray(res.data.data) ? res.data.data : [];
      console.log('Processed cities:', cities.length);
      return cities;
    } catch (error) {
      console.error('Error fetching cities:', error);
      return [];
    }
  };

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.log('No token found for categories');
        return [];
      }
      console.log('Fetching categories from API...');
      const res = await axios.get(
        "https://visitguru.in/api/v1/category/getCategory",
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 30000
        }
      );
      console.log('Categories API response:', res.data);
      if (res.data.success && Array.isArray(res.data.data)) {
        const categories = res.data.data.map((cat) => ({
          _id: cat._id || "",
          name: cat.name || cat.categoryName || cat.title || "Unnamed",
        }));
        console.log('Processed categories:', categories.length);
        return categories;
      }
      return [];
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  };

  const fetchCompletedTasksForVendor = async (vendorId) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return {
          completedTasksCount: 0,
          completedTasksTotalEarning: 0,
        };
      }

      const res = await fetch(
        "https://visitguru.in/api/v1/bookservice/completedTasklist",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ shopID: vendorId }),
        }
      );

      if (!res.ok) {
        return {
          completedTasksCount: 0,
          completedTasksTotalEarning: 0,
        };
      }

      const data = await res.json();
      console.log('💰 Completed tasks for vendor', vendorId, ':', data);
      if (data.success) {
        return {
          completedTasksCount: data.totalCompletedTasks || 0,
          completedTasksTotalEarning: data.completedEarnings || 0,
        };
      }

      return {
        completedTasksCount: 0,
        completedTasksTotalEarning: 0,
      };
    } catch (error) {
      console.error('Error fetching completed tasks:', error);
      return {
        completedTasksCount: 0,
        completedTasksTotalEarning: 0,
      };
    }
  };

  const fetchAllData = async (page = 1, useBackendFilters = false) => {
    try {
      console.log(`fetchAllData called with page: ${page}, useBackendFilters: ${useBackendFilters}`);

      // Always fetch cities and categories first if not loaded
      let cityList = cities;
      let categoryList = categories;

      if (cities.length === 0) {
        console.log('Fetching cities...');
        cityList = await fetchCities();
        console.log('Cities fetched:', cityList.length);
        setCities(cityList);
        await delay(500);
      }

      if (categories.length === 0) {
        console.log('Fetching categories...');
        categoryList = await fetchCategories();
        console.log('Categories fetched:', categoryList.length);
        setCategories(categoryList);
        await delay(500);
      }

      // Now fetch vendors with proper city/category data available
      const vendorData = await fetchVendors(page, useBackendFilters);

      console.log('Setting vendors:', vendorData.vendors.length);
      console.log('Setting totalPages:', vendorData.totalPages);
      console.log('Setting totalVendors:', vendorData.totalVendors);

      setVendors(vendorData.vendors);
      setTotalPages(vendorData.totalPages);
      setTotalVendors(vendorData.totalVendors);

      const uniquePincodes = [
        ...new Set(
          vendorData.vendors.map((v) => (v.pincode || "").toString()).filter(Boolean)
        ),
      ];

      setPincodes(uniquePincodes);
      setFilteredPincodes(uniquePincodes);
      
      // Fetch completed tasks for all vendors
      const tasksInfo = {};
      for (const vendor of vendorData.vendors) {
        if (vendor._id) {
          const taskData = await fetchCompletedTasksForVendor(vendor._id);
          tasksInfo[vendor._id] = taskData;
        }
      }
      setVendorTasksInfo(tasksInfo);
      console.log('📈 Vendor tasks info loaded:', tasksInfo);
    } catch (error) {
      console.error('Error in fetchAllData:', error);
      toast.error("Error fetching data: " + error.message);
    }
  };

  const handlePageChange = (newPage) => {
    console.log(`handlePageChange called: ${currentPage} -> ${newPage}`);
    console.log(`totalPages: ${totalPages}`);

    if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage) {
      setCurrentPage(newPage);
      const hasBackendFilters = Boolean(
        filters.registerAs || filters.city || filters.category || 
        filters.shopName || filters.pincode || filters.mobile || filters.employee ||
        filters.minEarning || filters.maxEarning || filters.minTask || filters.maxTask ||
        fromDate || toDate
      );
      fetchAllData(newPage, hasBackendFilters);
    }
  };

  const getCityNameById = (cityId) => {
    if (!cityId) return "N/A";
    const city = cities.find((c) => c._id === cityId);
    return city ? city.cityName : cityId || "N/A";
  };

  const getCategoryName = (categoryValue) => {
    if (!categoryValue) return "N/A";
    if (Array.isArray(categoryValue)) {
      return (
        categoryValue
          .map((catId) => {
            const cat = categories.find((c) => c._id === catId || c.name === catId);
            return cat ? cat.name : catId;
          })
          .join(", ") || "N/A"
      );
    }
    const cat = categories.find(
      (c) => c._id === categoryValue || c.name === categoryValue
    );
    return cat ? cat.name : categoryValue || "N/A";
  };

  useEffect(() => {
    const initializeData = async () => {
      console.log('Initializing data...');
      // First load cities and categories
      const [cityList, categoryList] = await Promise.all([
        fetchCities(),
        fetchCategories()
      ]);
      
      console.log('Initial cities loaded:', cityList.length);
      console.log('Initial categories loaded:', categoryList.length);
      
      setCities(cityList);
      setCategories(categoryList);
      
      // Then load vendors
      await fetchAllData(currentPage);
    };
    
    initializeData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cityDropdownRef.current && !cityDropdownRef.current.contains(event.target)) {
        setIsCityOpen(false);
      }
      if (pincodeDropdownRef.current && !pincodeDropdownRef.current.contains(event.target)) {
        setIsPincodeOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (searchPincode.trim() === "") {
      setFilteredPincodes(pincodes);
    } else {
      const lowerSearch = searchPincode.toLowerCase();
      const filtered = pincodes.filter((p) =>
        p.toString().toLowerCase().includes(lowerSearch)
      );
      setFilteredPincodes(filtered);
    }
  }, [searchPincode, pincodes]);

  const filteredCities = cities.filter((city) => {
    if (!city || !city.cityName) return false;
    return city.cityName.toLowerCase().includes(searchCity.toLowerCase());
  });

  const vendorEarningsMap = completedTasks.reduce((acc, task) => {
    const id = task.shopID?._id;
    const price = Number(task.price) || 0;
    if (id) acc[id] = (acc[id] || 0) + price;
    return acc;
  }, {});

  const vendorTaskCountMap = completedTasks.reduce((acc, task) => {
    const id = task.shopID?._id;
    if (id) acc[id] = (acc[id] || 0) + 1;
    return acc;
  }, {});

  const applyFilters = () => {
    if (!vendors || !Array.isArray(vendors)) {
      console.warn("Vendors array is not initialized or not an array:", vendors);
      setFilteredVendors([]);
      return;
    }
    // Backend handles all filters now, just pass through
    setFilteredVendors(vendors);
  };

  useEffect(() => {
    applyFilters();
  }, [vendors]);

  useEffect(() => {
    setFilteredVendors(vendors);
  }, [vendors]);

  const handlePrev = () => handlePageChange(Math.max(currentPage - 1, 1));
  const handleNext = () => handlePageChange(Math.min(currentPage + 1, totalPages));

  const handleBlockVendor = async (vendorId) => {
    const vendor = vendors.find((v) => v._id === vendorId);
    if (!vendor) {
      toast.error("Vendor not found.");
      return;
    }
    const isBlocked = vendor.isBlocked;
    const actionText = isBlocked ? "unblock" : "block";

    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to ${actionText} this vendor?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isBlocked ? "#98fb98" : "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: `Yes, ${actionText}!`,
    });

    if (confirmResult.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          `https://visitguru.in/api/v1/freelancer/block/${vendorId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ block: !isBlocked }),
          }
        );
        if (res.ok) {
          setVendors((prev) =>
            prev.map((v) => (v._id === vendorId ? { ...v, isBlocked: !isBlocked } : v))
          );
          setFilteredVendors((prev) =>
            prev.map((v) => (v._id === vendorId ? { ...v, isBlocked: !isBlocked } : v))
          );
          toast.success(`Vendor ${actionText}ed successfully!`);
        } else {
          toast.error("Failed to update status");
        }
      } catch (err) {
        toast.error("Failed to update status");
      }
    }
  };

  const handleDelete = async (vendorId) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this vendor? This will hide vendor and related data (soft delete).",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, delete!",
    });

    if (confirmResult.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.delete(
          `https://visitguru.in/api/v1/freelancer/vendor/${vendorId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (res.data.success) {
          setVendors((prev) => prev.filter((v) => v._id !== vendorId));
          setFilteredVendors((prev) => prev.filter((v) => v._id !== vendorId));
          toast.success("Vendor deleted successfully");
        } else {
          toast.error("Failed to delete vendor");
        }
      } catch (err) {
        toast.error("Delete failed");
      }
    }
  };

  const exportToPDF = async () => {
    toast.info("Preparing vendor report...");

    const vendorEarningsMap = {};
    const vendorTaskCountMap = {};

    if (Array.isArray(completedTasks) && completedTasks.length > 0) {
      completedTasks.forEach((task) => {
        const id = task?.shopID?._id;
        const price = Number(task.price) || 0;
        if (id) {
          vendorEarningsMap[id] = (vendorEarningsMap[id] || 0) + price;
          vendorTaskCountMap[id] = (vendorTaskCountMap[id] || 0) + 1;
        }
      });
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [215.9, 355.6],
    });

    doc.setFontSize(14);
    doc.text("Vendor Report", 14, 15);

    const tableColumn = [
      "#",
      "Name",
      "Shop Name",
      "Mobile",
      "City",
      "Categories",
      "Pincode",
      "Created At",
      "Total Earnings",
      "Completed Tasks",
      "Total Employees",
    ];

    const tableRows = filteredVendors.map((v, i) => {
      const completedCount =
        Number(vendorTasksInfo?.[v._id]?.completedTasksCount) ||
        vendorTaskCountMap[v._id] ||
        0;

      const totalEarnings =
        Number(vendorTasksInfo?.[v._id]?.completedTasksTotalEarning) ||
        vendorEarningsMap[v._id] ||
        0;

      return [
        i + 1,
        `${v.firstName || ""} ${v.lastName || ""}`.trim() || "N/A",
        v.shopName || "N/A",
        v.mobile || "N/A",
        Array.isArray(v.city)
          ? v.city.map(getCityNameById).join(", ")
          : getCityNameById(v.city),
        Array.isArray(v.category)
          ? v.category.map(getCategoryName).join(", ")
          : getCategoryName(v.category),
        v.pincode || "N/A",
        v.createdAt ? new Date(v.createdAt).toLocaleString() : "N/A",
        `₹${totalEarnings.toFixed(2)}`,
        completedCount,
        v.employees?.length || Number(v.totalEmployee) || 0,
      ];
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [40, 116, 166], textColor: [255, 255, 255] },
      didDrawPage: () => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
          doc.internal.pageSize.getWidth() - 40,
          doc.internal.pageSize.getHeight() - 10
        );
      },
    });

    doc.save("vendors.pdf");
    toast.success("Vendor PDF exported successfully!");
  };

  const toggleDetails = (id) =>
    setShowDetails((prev) => ({ ...prev, [id]: !prev[id] }));

  const onCityChange = (cityId) => {
    if (cityId === "") {
      setSelectedCity("");
      setFilters((prev) => ({ ...prev, city: "" }));
      console.log('City filter cleared');
    } else {
      const city = cities.find((c) => c._id === cityId);
      if (city) {
        setSelectedCity(city.cityName);
        // Send city name to backend (backend handles both name and ID)
        setFilters((prev) => ({ ...prev, city: city.cityName }));
        console.log('City selected:', city.cityName, 'ID:', city._id);
      }
    }
    setIsCityOpen(false);
    setSearchCity("");
  };

  const onPincodeChange = (pincode) => {
    setFilters((prev) => ({ ...prev, pincode: pincode === "All" ? "" : pincode }));
    setIsPincodeOpen(false);
    setSearchPincode("");
  };

  const applyBackendFilters = () => {
    console.log('=== APPLYING FILTERS ===');
    console.log('Current filters:', filters);
    
    // Backend filters (sent to API)
    const backendFilters = Boolean(
      filters.registerAs || filters.city || filters.category || 
      filters.shopName || filters.pincode || filters.mobile || filters.employee ||
      filters.minEarning || filters.maxEarning || filters.minTask || filters.maxTask ||
      fromDate || toDate
    );
    
    console.log('Backend filters active:', backendFilters);
    console.log('=== END FILTER DEBUG ===');
    
    setCurrentPage(1);
    fetchAllData(1, backendFilters);
  };

  const clearAllFilters = () => {
    console.log('Clearing all filters...');
    setFilters({
      registerAs: "",
      city: "",
      category: "",
      shopName: "",
      pincode: "",
      minTask: "",
      maxTask: "",
      minEarning: "",
      maxEarning: "",
      mobile: "",
      employee: "",
      fromDate: "",
      toDate: "",
    });
    setSelectedCity("");
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    fetchAllData(1, false);
  };

  return (
    <div className="vendor-container relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
      <ToastContainer />
      <div className="vendor-header px-4 py-3 border-b">
        <h2 className="font-semibold text-base text-blueGray-700 mb-2">
          Vendors{" "}
          <span className="ml-2 text-sm text-blueGray">(Total Vendor: {totalVendors})</span>
          <button
            style={{
              backgroundColor: "#0884c4",
              float: "right",
              width: "100px",
              height: "35px",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={exportToPDF}
          >
            Download
          </button>
        </h2>

        <style>{`
          .custom-scroll::-webkit-scrollbar { width: 8px; }
          .custom-scroll::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
          .custom-scroll::-webkit-scrollbar-thumb { background: #888; border-radius: 4px; }
          .custom-scroll::-webkit-scrollbar-thumb:hover { background: #555; }
          .custom-scroll { scroll-behavior: smooth; }
        `}</style>

        <div className="flex flex-wrap gap-4 mb-4">
        

          <div className="relative w-1/5" ref={cityDropdownRef}>
            <label style={{ width: "200px" }} className="block mb-1 text-sm font-medium text-gray-700">City</label>
            <div
              className="px-4 py-1 border border-blueGray-200 rounded cursor-pointer text-sm"
              onClick={() => {
                setIsCityOpen((prev) => !prev);
                setIsPincodeOpen(false);
              }}
            >
              {selectedCity || "Select City"}
            </div>

            {isCityOpen && (
              <div className="absolute z-10 bg-white border border-blueGray-200 mt-1 w-full rounded shadow-lg" style={{ maxHeight: "400px", overflowY: "auto", scrollbarWidth: "thin", width: "200px" }}>
                <input type="text" placeholder="Search city..." value={searchCity} onChange={(e) => setSearchCity(e.target.value)} className="w-full px-3 py-2 border-b border-blueGray-200 focus:outline-none text-sm" />
                <ul>
                  <li className="px-3 py-2 hover:bg-blue-100 cursor-pointer font-semibold" onClick={() => onCityChange("")}>All Cities</li>
                  {cities.length === 0 ? (
                    <li className="px-3 py-2 text-gray-500">Loading cities...</li>
                  ) : filteredCities.length > 0 ? filteredCities.map((city) => (
                    <li key={city._id} className="px-3 py-2 hover:bg-blue-100 cursor-pointer" onClick={() => onCityChange(city._id)}>
                      {city.cityName}
                    </li>
                  )) : <li className="px-3 py-2 text-gray-500">No cities found</li>}
                </ul>
              </div>
            )}
          </div>

          <div className="relative w-1/5">
            <label>Category</label>
            <select value={filters.category} onChange={(e) => {
              setFilters((prev) => ({ ...prev, category: e.target.value }));
              console.log('Category selected:', e.target.value);
            }} className="w-full px-3 py-1 h-6 border border-blueGray-200 rounded focus:outline-none focus:ring custom-scroll">
              <option value="">All Categories</option>
              {categories.length === 0 ? (
                <option disabled>Loading categories...</option>
              ) : categories.map((category) => (
                <option key={category._id} value={category.name}>{category.name}</option>
              ))}
            </select>
          </div>

          <div className="relative w-1/5" ref={pincodeDropdownRef}>
            <label>Pincode</label>
            <div className="px-3 py-1 border border-blueGray-200 rounded cursor-pointer" onClick={() => { setIsPincodeOpen((prev) => !prev); setIsCityOpen(false); }}>
              {filters.pincode || "Select Pincode"}
            </div>

            {isPincodeOpen && (
              <div className="absolute z-10 bg-white border border-blueGray-200 mt-1 w-full rounded shadow-lg" style={{ maxHeight: "300px", overflowY: "auto", scrollBehavior: "smooth" }}>
                <input type="text" placeholder="Search pincode..." value={searchPincode} onChange={(e) => setSearchPincode(e.target.value)} className="w-full px-3 py-2 border-b border-blueGray-200 focus:outline-none" />
                <ul>
                  <li className="px-3 py-2 hover:bg-blue-100 cursor-pointer" onClick={() => onPincodeChange("All")}>All Pincodes</li>
                  {filteredPincodes.length > 0 ? filteredPincodes.map((pincode, index) => (
                    <li key={index} className="px-3 py-2 hover:bg-blue-100 cursor-pointer" onClick={() => onPincodeChange(pincode)}>{pincode}</li>
                  )) : <li className="px-3 py-2 text-gray-500">No pincodes found</li>}
                </ul>
              </div>
            )}
          </div>

          <div className="w-1/5">
            <label>Shopname</label>
            <input type="text" value={filters.shopName || ""} onChange={(e) => setFilters((prev) => ({ ...prev, shopName: e.target.value }))} placeholder="Search Shop Name" className="w-full px-3 py-1 border border-blueGray-200 rounded focus:outline-none focus:ring" />
          </div>

          <div className="w-1/5">
            <label>Mobile</label>
            <input type="text" value={filters.mobile || ""} onChange={(e) => setFilters((prev) => ({ ...prev, mobile: e.target.value }))} placeholder="Search Mobile Number" className="w-full px-3 py-1 border border-blueGray-200 rounded focus:outline-none focus:ring" />
          </div>

          <div className="w-1/5">
            <label className="block text-sm font-medium text-gray-700 mb-1">Employee Count</label>
            <input type="number" placeholder="Exact count (e.g., 4)" value={filters.employee} onChange={(e) => setFilters((prev) => ({ ...prev, employee: e.target.value }))} className="w-full px-3 py-1 border border-blueGray-200 rounded focus:outline-none focus:ring" />
          
          </div>

          
        </div>

        <div className="flex flex-wrap gap-4 mb-3">
          <div>
            <label>Min Task</label>
            <input style={{ width: "110px" }} type="number" placeholder="Min" min="0" value={filters.minTask} onChange={(e) => setFilters((prev) => ({ ...prev, minTask: e.target.value }))} className="px-3 py-2 border border-blueGray-200 rounded focus-outline-none" />
          </div>
          <div>
            <label>Max Task</label>
            <input style={{ width: "110px" }} type="number" placeholder="Max" min="0" value={filters.maxTask} onChange={(e) => setFilters((prev) => ({ ...prev, maxTask: e.target.value }))} className="px-3 py-2 border border-blueGray-200 rounded focus-outline-none" />
          </div>
          <div>
            <label>Min Earning</label>
            <input style={{ width: "110px" }} type="number" placeholder="Min" min="0" value={filters.minEarning} onChange={(e) => setFilters((prev) => ({ ...prev, minEarning: e.target.value }))} className="px-3 py-2 border border-blueGray-200 rounded focus-outline-none" />
          </div>
          <div>
            <label>Max Earning</label>
            <input style={{ width: "110px" }} type="number" placeholder="Max" min="0" value={filters.maxEarning} onChange={(e) => setFilters((prev) => ({ ...prev, maxEarning: e.target.value }))} className="px-3 py-2 border border-blueGray-200 rounded focus-outline-none" />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1">From</label>
            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="w-40 border rounded-md px-2 py-1 text-sm" />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1">To</label>
            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} className="w-40 border rounded-md px-2 py-1 text-sm" />
          </div>
          <div className="flex gap-3">
            <button 
              onClick={applyBackendFilters}
              className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors font-semibold"
              disabled={loading}
              style={{ marginTop: "20px", fontSize: "16px" , backgroundColor:"#2596be" }}
            >
              {loading ? "Sending..." : "📤 Send Filters"}
            </button>
            <button 
              onClick={clearAllFilters}
              className="bg-red-500 text-white px-6 py-3 rounded-lg hover:bg-red-600 transition-colors font-semibold"
              disabled={loading}
              style={{ marginTop: "20px", fontSize: "16px" }}
            >
              🗑️ Clear All
            </button>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full bg-transparent border-collapse">
          <thead>
            <tr>
              {[
                "#",
                "Vendor ID",
                "Name",
                "Shop Name",
                "Mobile",
                "Actions",
              ].map((head, i) => (
                <th key={i} className="px-6 py-3 bg-blueGray-50 text-blueGray-500 border border-solid border-blueGray-100 text-xs uppercase font-semibold text-left">
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="text-center p-8">
                  <div className="flex flex-col items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                    <p className="text-gray-600">Loading vendors...</p>
                  </div>
                </td>
              </tr>
            ) : filteredVendors.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-4 text-sm text-gray-500">No vendors found.</td>
              </tr>
            ) : (
              filteredVendors.map((vendor, index) => {
                const id = vendor._id || `${index}-${vendor.mobile || "unknown"}`;
                const displayedTasks =
                  Number(vendorTasksInfo[vendor._id]?.completedTasksCount) ||
                  vendorTaskCountMap[vendor._id] ||
                  0;
                const displayedEarnings =
                  Number(vendorTasksInfo[vendor._id]?.completedTasksTotalEarning) ||
                  vendorEarningsMap[vendor._id] ||
                  0;

                return (
                  <React.Fragment key={id}>
                    <tr>
                      <td className="px-6 py-4 text-xs border-t border-blueGray-100">{(currentPage - 1) * limit + index + 1}</td>
                      <td className="px-6 py-4 text-xs border-t border-blueGray-100">{totalVendors - ((currentPage - 1) * limit + index)}</td>
                      <td className="px-6 py-4 text-xs border-t border-blueGray-100">{`${vendor.firstName || ""} ${vendor.lastName || ""}`.trim() || "N/A"}</td>
                      <td className="px-6 py-4 text-xs border-t border-blueGray-100" style={{ maxWidth: "200px", wordWrap: "break-word", whiteSpace: "normal" }}>{vendor.shopName || "N/A"}</td>
                      <td className="px-6 py-4 text-xs border-t border-blueGray-100">{vendor.mobile || "N/A"}</td>
                      <td className="px-6 py-4 text-xs border-t border-blueGray-100">
                        <button onClick={() => toggleDetails(id)} style={{ backgroundColor: "#0884c4" }} className="text-white px-3 py-1 rounded hover:bg-blue-700 transition duration-150">
                          {showDetails[id] ? "Hide Details" : "View Details"}
                        </button>
                        <button onClick={() => handleBlockVendor(vendor._id)} style={{ color: "white", fontWeight: "bold", marginLeft: "0.5rem", padding: "0.25rem 0.75rem", borderRadius: "0.25rem", transition: "all 0.15s ease", backgroundColor: vendor.isBlocked ? "#2f855a" : "#ef4444" }} className={vendor.isBlocked ? "hover:bg-green-600" : "hover:bg-red-600"}>
                          {vendor.isBlocked ? "Unblock" : "Block"}
                        </button>
                        <button onClick={() => handleDelete(vendor._id)} style={{ backgroundColor: "#ef4444", color: "white", fontWeight: "bold", marginLeft: "0.5rem", padding: "0.25rem 0.75rem", borderRadius: "0.25rem", transition: "all 0.15s ease" }} className="hover:bg-red-600">
                          Delete
                        </button>
                      </td>
                    </tr>

                    {(vendor.employees && vendor.employees.length > 0) || (vendor.employeeNames && vendor.employeeNames.length > 0) ? (
                      <tr>
                        <td colSpan="6" className="px-6 py-2 text-xs border-t border-blueGray-100 bg-gray-50">
                          <div className="max-h-32 overflow-y-auto">
                            <table className="w-full text-xs">
                              <thead className="bg-blueGray-200">
                                <tr>
                                  <th className="px-2 py-1 text-left">No.</th>
                                  <th className="px-2 py-1 text-left">Name</th>
                                </tr>
                              </thead>
                              <tbody>
                                {vendor.employees && vendor.employees.length > 0 ? (
                                  vendor.employees.map((emp, i) => (
                                    <tr key={i} className="border-b">
                                      <td className="px-2 py-1">{i + 1}</td>
                                      <td className="px-2 py-1">{emp.firstName} {emp.lastName}</td>
                                    </tr>
                                  ))
                                ) : (
                                  vendor.employeeNames.map((name, i) => (
                                    <tr key={i} className="border-b">
                                      <td className="px-2 py-1">{i + 1}</td>
                                      <td className="px-2 py-1">{name}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    ) : null}

                    {showDetails[id] && (
                      <tr>
                        <td colSpan="10" className="bg-gray-100 px-6 py-4 text-xs">
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <p><strong>Full Name:</strong> {`${vendor.firstName || ""} ${vendor.lastName || ""}`.trim() || "N/A"}</p>
                              <p><strong>Email:</strong> {vendor.email || "N/A"}</p>
                              <p><strong>Mobile:</strong> {vendor.mobile || "N/A"}</p>
                              <p><strong>Emergency Mobile:</strong> {vendor.Emergencymobile || "N/A"}</p>
                              <p><strong>DOB:</strong> {vendor.DOB ? new Date(vendor.DOB).toLocaleDateString() : "N/A"}</p>
                              <p><strong>Registered As:</strong> {vendor.registerAs || vendor.registeredAs || "N/A"}</p>
                              <p><strong>Created At:</strong> {vendor.createdAt ? new Date(vendor.createdAt).toLocaleString() : "N/A"}</p>
                            </div>

                            <div>
                              <p><strong>Shop Name:</strong> {vendor.shopName || "N/A"}</p>
                              <p><strong>Address:</strong> {vendor.address || "N/A"}</p>
                              <p><strong>Area/State:</strong> {vendor.area || "N/A"}</p>
                              <p><strong>City:</strong> {Array.isArray(vendor.city) ? vendor.city.map(getCityNameById).join(", ") : getCityNameById(vendor.city)}</p>
                              <p><strong>Pincode:</strong> {vendor.pincode || "N/A"}</p>
                              <p><strong>Category Verified:</strong> {vendor.categoryVerified ? "Yes" : "No"}</p>
                              <p><strong>Is Verified:</strong> {vendor.isVerified ? "Yes" : "No"}</p>
                              <p><strong>Status:</strong> {vendor.isBlocked ? "Blocked" : "Active"}</p>
                            </div>
                          </div>

                          <div className="mt-4">
                            <h4 className="font-bold mb-2 text-sm">Categories</h4>
                            <div className="flex flex-wrap gap-2">
                              {vendor.categoryData?.length > 0 ? vendor.categoryData.map((cat, i) => (
                                <span key={i} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                  {cat.categoryName || cat.name}
                                </span>
                              )) : (
                                Array.isArray(vendor.category) ? vendor.category.map((catId, i) => (
                                  <span key={i} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                    {getCategoryName(catId)}
                                  </span>
                                )) : (
                                  <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                    {getCategoryName(vendor.category)}
                                  </span>
                                )
                              )}
                            </div>
                          </div>

                          <div className="mt-4">
                            <div className="grid grid-cols-3 gap-4">
                              <p><strong>Total Tasks:</strong> {vendor.totalTask || vendor.tasks?.length || 0}</p>
                              <p><strong>Completed Tasks:</strong> {displayedTasks}</p>
                              <p><strong>Total Earnings:</strong> ₹{displayedEarnings}</p>
                            </div>
                          </div>
                          <div className="mt-4">
                            <h4 className="font-bold mb-2 text-sm">Employee Details ({vendor.totalEmployee || 0})</h4>
                            <div className="max-h-32 overflow-y-auto border rounded">
                              <table className="w-full text-xs">
                                <thead className="bg-blueGray-200 sticky top-0">
                                  <tr>
                                    <th className="px-2 py-1 text-left">No.</th>
                                    <th className="px-2 py-1 text-left">Name</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {vendor.employees?.length > 0 ? (
                                    vendor.employees.map((emp, i) => (
                                      <tr key={i} className="border-b">
                                        <td className="px-2 py-1">{i + 1}</td>
                                        <td className="px-2 py-1">{emp.firstName} {emp.lastName}</td>
                                      </tr>
                                    ))
                                  ) : vendor.employeeNames?.length > 0 ? (
                                    vendor.employeeNames.map((name, i) => (
                                      <tr key={i} className="border-b">
                                        <td className="px-2 py-1">{i + 1}</td>
                                        <td className="px-2 py-1">{name}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="2" className="text-center text-gray-500 py-2">No employees found</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div className="flex justify-between items-center p-4">
        <button
          onClick={handlePrev}
          disabled={currentPage === 1 || loading}
          className="px-4 py-2 bg-blueGray-200 rounded disabled:opacity-50 flex items-center gap-2"
        >
          {loading && currentPage > 1 ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
          ) : null}
          Prev
        </button>
        <span className="flex items-center gap-2">
          {loading ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
          ) : null}
          Page {currentPage} of {totalPages} 
          {Boolean(filters.registerAs || filters.city || filters.category || filters.shopName || filters.pincode || filters.mobile || filters.employee || filters.minEarning || filters.maxEarning || filters.minTask || filters.maxTask || fromDate || toDate) && (
            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded ml-2">
              (Filtered: {totalVendors} results)
            </span>
          )}
        </span>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages || loading}
          className="px-4 py-2 bg-blueGray-200 rounded disabled:opacity-50 flex items-center gap-2"
        >
          Next
          {loading && currentPage < totalPages ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
          ) : null}
        </button>
      </div>
    </div>
  );
};

export default Vendors;